import { createElement } from 'react';
import { IModalInkFeaturesList } from '../types';
import {
  Container,
  FeatureIcon,
  FeatureItem,
  FeaturesList,
  FeatureText,
  Subtitle,
} from './styles';
export const PrintPlanFeatures = ({
  subtitle,
  features,
}: {
  subtitle: string;
  features: IModalInkFeaturesList[];
}) => {
  return (
    <Container>
      <Subtitle>{subtitle}</Subtitle>
      <FeaturesList>
        {features.map(({ icon: Icon, text }) => (
          <FeatureItem key={text}>
            <FeatureIcon>{Icon && createElement(Icon)}</FeatureIcon>
            <FeatureText>{text}</FeatureText>
          </FeatureItem>
        ))}
      </FeaturesList>
    </Container>
  );
};
